import MeetingManagerPage from "@Evaluation/Estimations/Pages/MeetingManagerPage.vue";
import PanelistAlternativePage from "@Evaluation/Estimations/Pages/PanelistAlternativePage.vue";
import PanelistDashboardPage from "@Evaluation/Estimations/Pages/PanelistDashboardPage.vue";
import PanelistMeetingPage from "@Evaluation/Estimations/Pages/PanelistMeetingPage.vue";
import PanelistsPage from "@Evaluation/Estimations/Pages/PanelistsPage.vue";
import PanelsPage from "@Evaluation/Estimations/Pages/PanelsPage.vue";


export const routes = [

    //Manage Panels
    { path: "/portfolio/assessments/:workspaceId/:projectId", component: PanelsPage },
    { path: "/decision/assessments/:workspaceId/:projectId",  component: PanelsPage },

    //Meeting Manager
    { path: "/portfolio/assessments-review/:workspaceId/:projectId/:surveyId", component: MeetingManagerPage },
    { path: "/decision/assessments-review/:workspaceId/:projectId/:surveyId", component: MeetingManagerPage },

    //Manage panelists
    { path: "/portfolio/assessments-panelists/:workspaceId/:projectId/:surveyId", component: PanelistsPage },
    { path: "/decision/assessments-panelists/:workspaceId/:projectId/:surveyId", component: PanelistsPage },


    {
        path: "/est/dashboard/:workspaceId/:surveyId/:projectUserId",
        component: PanelistDashboardPage,
    },
    {
        path: "/est/alternative/:workspaceId/:surveyId/:projectUserId/:alternativeId",
        component: PanelistAlternativePage,
    },
    {
        path: "/est/meeting/:workspaceId/:surveyId/:projectUserId",
        component: PanelistMeetingPage,
    },
]
